import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    counterPushData: {},
    counterBasketData: {},
    counterData: {},
  },
  mutations: {
    SET_DATA(state, data) {
      state.counterData = data.data;
      state.counterBasketData = data.data.basket;
      state.counterPushData = data.data.push;
      state.loaded = true;
    },
    ADD_BASKET(state, id) {
      if (!state.counterBasketData.ids.includes(id))
      state.counterBasketData.ids.push(id);
    },
  },
  actions: {
    async fetchCounterData({ commit, state }, update=false) {
      if (update!== true && state.loaded && state.counterData) {
        return;
      }

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/counter/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
        console.error('Error fetching:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Force refresh method (optional) if you need to manually refresh the data
    async refreshCounterData({ commit, dispatch }) {
      commit('SET_LOADING', true);
      commit('SET_COUNTER_DATA', null);
      commit('SET_ERROR', null);
      commit('RESET_LOADED_STATE');
      await dispatch('fetchCounterData');
    }
  },
  getters: {
    counterData: state => state.counterData,
    counterBasketData: state => state.counterBasketData,
    counterPushData: state => state.counterPushData,
    counterLoading: state => state.loading,
    counterError: state => state.error,
    counterLoaded: state => state.loaded
  }
})
